export enum RequestType {
  GET,
  POST,
  PUT,
  DELETE,
  OPTIONS,
  REQUEST
};
